import { StatTile } from './types';

export const STAT_TILES: StatTile[] = [
  {key: 'attendance', label: 'Attendance', value: ' - '},
  {key: 'performance', label: 'Performance', value: ' - '},
  {key: 'tasks', label: 'Tasks Completed', value: ' - '},
  {key: 'training', label: 'Training Progress', value: ' - '},
];

export const TILE_DETAILS: Record<string, { title: string; content: string }> = {
  attendance: {title: 'Attendance details', content: 'No data found'},
  performance: {title: 'Performance Overview', content: 'No data found'},
  tasks: {title: 'Tasks Completed', content: 'No data found'},
  training: {title: 'Training Progress', content: 'No data found'},
};
